import CultureFlag from "components/Culture/CultureFlag";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import React from "react";

interface Props {
  contact: server.dto.Contact
  displayPreview?: boolean
  displayDetails?: boolean
}

const ReadonlyContact = (props: Props) => {
  const { contact, displayPreview, displayDetails } = props;

  if (contact == null) {
    return <div className="s1_gray" style={{ flex: 1 }}>
      {RESX.Contact.NoContactSelected}
    </div>;
  }

  return <div className="flex gap" style={{ flex: 1 }}>
    <div>
      <CultureFlag lcid={contact.culture} size="small" />
    </div>
    <div>
      {displayPreview && (<ContactSidePanel
        contactId={contact.contactId}
        trigger={<a>
          {contact.name.fullName}
        </a>} />)}

      {!displayPreview && <span>{contact.name.fullName}</span>}

      {displayDetails && <>
        {contact.position != null && <div>{contact.position}</div>}
        {contact.mobileNumbers.map((m, idx) => <div key={idx}>{m}</div>)}
        {contact.emailAddresses.map((e, idx) => <div key={idx}><a href={`mailto:${e}`}>{e}</a></div>)}
      </>}
    </div>
  </div>;
};

export default ReadonlyContact;
